var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWobblyCircleSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.574 54.412a33.158 33.158 0 01-16.341-9.264l.07-.024a1.627 1.627 0 01-.225-.327C2.77 39.93-.233 33.029.117 26.995a28.02 28.02 0 018.077-17.19 46.885 46.885 0 018.8-7.054A22.223 22.223 0 0132.403.4a27.152 27.152 0 0114.733 7.63 27.486 27.486 0 017.612 14.82 27.597 27.597 0 01-2.326 16.52 27.335 27.335 0 01-11.404 12.103 26.61 26.61 0 01-18.443 2.94z",
    fill: "url(#wobbly-circle-second_svg__paint0_linear_8914_135)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "wobbly-circle-second_svg__paint0_linear_8914_135",
    x1: 55.132,
    y1: 54.946,
    x2: -9.621,
    y2: 38.751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#660F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC1E66"
  })))));
}
export default SvgWobblyCircleSecond;